export enum TestTableStatus {
  PASS = 'pass',
  FAIL = 'fail',
}
